import { version } from "../../../package.json";
export default {
  state: {
    frontEndVersion: version,
    config: {}
  },
  mutations: {
    frontEndVersion(state, value) {
      state.frontEndVersion = value;
    },
    config(state, value) {
      state.config = value;
    }
  },
  actions: {
    setFrontEndVersion({ commit }, value) {
      commit("frontEndVersion", value);
    },
    setConfig({ commit }, value) {
      commit("config", value);
    }
  },
  getters: {
    getFrontEndVersion: state => {
      return state.frontEndVersion;
    },
    getConfig: state => {
      return state.config;
    }
  }
};
